import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";
import { ReactComponent as CameraIcon } from "./camera.svg";

import { getAppValue } from "src/utils/environment";

export default function CameraPermissionDialog({ isOpen, onDismiss, openSettings, emitter }) {
  const { t } = useTranslation();

  const handleDismiss = () => {
    emitter.emit("camera-dialog-dismiss");
    onDismiss();
  };

  return (
    <Dialog
      icon={CameraIcon}
      iconBg={getAppValue({
        barkio: "tint3Light",
        bibino: "secondaryLight"
      })}
      iconFill={getAppValue({ barkio: "tint3", bibino: "secondary" })}
      buttons={[
        { text: t("buttons.cancel"), onClick: handleDismiss },
        { text: t("settings"), onClick: openSettings }
      ]}
      heading={t("app.cameraPermissionDialog.heading")}
      text={t("app.cameraPermissionDialog.text")}
      isOpen={isOpen}
      zIndex={101}
    />
  );
}
